/* tslint:disable */
/* eslint-disable */

/**
 * partnerDriverWeb driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export * from './BrandEnum';
export * from './ConditionBase';
export * from './ConditionImmediate';
export * from './ConditionUnion';
export * from './ConditionValidationFailed';
export * from './ConditionWithDelay';
export * from './DriverRegistrationLogSource';
export * from './DriverRegistrationLogStatus';
export * from './DriverRegistrationLogStep';
export * from './FleetUploadedDocument';
export * from './GetActualDriverRegistrationResponse';
export * from './GetAvailableSupportOptionsResponse';
export * from './GetDocumentCaptureModeResponse';
export * from './GetMqttConnectionInfoResponse';
export * from './GetSupportCaseWidgetUrlResponse';
export * from './GetSupportWidgetUrlResponse';
export * from './GetUnreadCasesWithLastMessageResponse';
export * from './StandardRequest';
export * from './SupportCondition';
export * from './SupportOptionArticle';
export * from './SupportOptionBase';
export * from './SupportOptionChat';
export * from './SupportOptionStandard';
export * from './SupportOptionUnion';
export * from './SupportType';
export * from './TriggerDocumentUploadRequest';
export * from './TriggerDocumentUploadResponse';
export * from './UnreadCaseWithLastMessage';
